import { render, staticRenderFns } from "./UIVersionAlert.vue?vue&type=template&id=23de04b0&scoped=true"
import script from "./UIVersionAlert.vue?vue&type=script&lang=ts"
export * from "./UIVersionAlert.vue?vue&type=script&lang=ts"
import style0 from "./UIVersionAlert.scss?vue&type=style&index=0&id=23de04b0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de04b0",
  null
  
)

export default component.exports